import { v4 as uuid } from "uuid";
import {Collection} from "../base/Collection";

export class LocationHistoryModel  {
    key: string = "";
    location:string = "";
    urlParams:any = null;

    constructor() {
    }

}
